module.exports = __webpack_public_path__ + "img/16_49.9201c888.png";